export const routeParams = {
	loadDietFoods: 'loadDietFoods',
	loadProgressTypes: 'loadProgressTypes',
	loadTasks: 'loadTasks',
	loadPackages: 'loadPackages',
	loadClientSessionForDate: 'loadClientSessionForDate',
	loadTrainer: 'loadTraner'
} as const;
